<template>
  <div>
    <step-header :step="step" :total="questions.length" />
    <submit-item :key="step" :question="question" @input="setAnswer" :disabled="submission.submitted" />
    <div class="submit-row">
      <button
        type="button"
        class="button is-primary is-rounded"
        :disabled="!valid_input"
        @click="nextStep">Skicka svar!</button>
    </div>
  </div>
</template>

<script>
import SubmitItem from './SubmitItem'
import StepHeader from '@/components/assignments/StepHeader.vue'

export default {
  props: {
    step: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      submission: {
        answer: null
      }
    }
  },
  computed: {
    assignment() {
      return this.$store.state.assignment
    },
    questions() {
      return this.assignment.task.config.questions
    },
    question() {
      return this.questions[this.step - 1]
    },
    valid_input(){
      return this.submission.answer && this.submission.answer.length >= 3
    }
  },
  components: {
    SubmitItem,
    StepHeader
  },
  methods: {
    nextStep() {
      this.submission.submitted = true
      let sub = this.assignment.submission
      sub.questions[this.step - 1] = this.submission
      this.$store.commit('setSubmission', sub)

      if (this.step == this.questions.length) {
        this.$store.dispatch('submitAssignment', true)
        .then(() => {
          this.$router.push(`/assignment/${this.assignment.slug}/confirmation`)
        })
      } else {
        this.$store.dispatch('submitAssignment', false)
        .then(() => {
          this.$router.push(`/assignment/${this.assignment.slug}/step/${this.step + 1}`)
        })
      }
    },
    setAnswer(answer) {
      this.submission.answer = answer
    }
  },
  mounted () {
    if (!this.assignment.submission.hasOwnProperty('questions')) {
      this.$store.commit('setSubmission', {questions: this.questions.map(q => {
        return {text: q, answer: null, submitted: false}
      })})
    }
    this.submission = this.assignment.submission.questions[this.step - 1]
  }
}
</script>
<style>
.submit-row {
  justify-content: flex-end;
  display: flex;
}
</style>
